var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyHhmtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.637 3.818C7.637 2.814 8.45 2 9.455 2h4.318c.126 0 .227.102.227.227v4.318c0 1.005.814 1.819 1.819 1.819h4.318c.125 0 .227.101.227.227v7.955a1.818 1.818 0 0 1-1.818 1.818H9.455a1.818 1.818 0 0 1-1.818-1.819V3.819Z",
    fill: "#1C3F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 6.455V2.604a.25.25 0 0 1 .426-.177l4.6 4.6a.25.25 0 0 1-.176.428h-3.85a1 1 0 0 1-1-1Z",
    fill: "#1C3F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.727 5.637h-.909A1.818 1.818 0 0 0 4 7.455v12.727C4 21.186 4.814 22 5.818 22h9.091a1.818 1.818 0 0 0 1.818-1.818v-.909H8.545a1.818 1.818 0 0 1-1.818-1.818V5.637Z",
    fill: "#1C3F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHhmtIcon);
export default __webpack_public_path__ + "static/media/copy-hhmt-icon.500871e4905d289ca009742361568b52.svg";
export { ForwardRef as ReactComponent };